export function RepositoryFileSkeleton() {
  return (
    <div className="flex items-center justify-between py-3 bg-white border-b border-innoveraZinc-150 animate-pulse">
      <div className="flex items-end gap-1 min-w-0 flex-1">
        <div className="w-[28px] h-[36px] rounded-[5px] bg-innoveraZinc-100" />

        <div className="flex-1 min-w-0 space-y-2">
          <div className="h-4 w-[200px] bg-innoveraZinc-100 rounded" />
          <div className="h-3 w-[150px] bg-innoveraZinc-100 rounded" />
        </div>
      </div>

      <div className="flex-shrink-0 ml-4">
        <div className="w-8 h-8 rounded bg-innoveraZinc-100" />
      </div>
    </div>
  );
}
